import React from 'react';
import { Button } from '@/components/ui/button';
import { LogOut, Home as HomeIcon } from 'lucide-react';
import NotificationCenter from '@/components/notifications/NotificationCenter';
import { useNavigate } from 'react-router-dom';

interface OwnerHeaderProps {
  onLogout: () => void;
  landlordId: string;
}

const OwnerHeader = ({ onLogout, landlordId }: OwnerHeaderProps) => {
  const navigate = useNavigate();

  const handleNotificationClick = () => {
    navigate('/notifications?type=landlord');
  };

  return (
    <nav className="bg-gradient-to-r from-blue-900 to-blue-800 shadow-lg border-b border-blue-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center space-x-3 rtl:space-x-reverse">
            <img 
              src="/lovable-uploads/b93b5bad-cffe-4247-aa30-5fa8a0d5cc9a.png" 
              alt="شعار كنف" 
              className="h-10 w-auto"
            />
            <div className="text-right">
              <span className="text-2xl font-bold text-white">لوحة المالك</span>
              <p className="text-sm text-blue-200">منصة كنف العقارية</p>
            </div>
          </div>
          <div className="flex items-center space-x-4 rtl:space-x-reverse">
            {landlordId && (
              <NotificationCenter userType="landlord" userId={landlordId} />
            )}
            <Button 
              onClick={onLogout} 
              variant="outline" 
              className="bg-red-600 border-red-600 text-white hover:bg-red-700 hover:border-red-700"
            >
              <LogOut className="h-4 w-4 mr-2" />
              تسجيل الخروج
            </Button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default OwnerHeader;